import { render, staticRenderFns } from "./FormFieldset.vue?vue&type=template&id=2acb147e&"
import script from "./FormFieldset.vue?vue&type=script&lang=js&"
export * from "./FormFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports